module.exports = __webpack_public_path__ + "img/3.5498f5d0.webp";